import { render, staticRenderFns } from "./supportive_investigation.vue?vue&type=template&id=00cefaf4&scoped=true&"
import script from "./supportive_investigation.vue?vue&type=script&lang=js&"
export * from "./supportive_investigation.vue?vue&type=script&lang=js&"
import style0 from "./supportive_investigation.vue?vue&type=style&index=0&id=00cefaf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cefaf4",
  null
  
)

export default component.exports